<template>
  <div>
    <el-container class="px-3 mt-4">
      <div>
        <search @onSearch="onSearch" :hide_payment="false">
          <el-form-item v-if="$route.meta.action.e" label=" ">
            <ExportExcel :condition="condition" :sale_ordering="sale_ordering" />
          </el-form-item>
        </search>
      </div>
    </el-container>

    <div class="text-right">
      <el-pagination background :current-page.sync="currentPage" :page-sizes="[10, 20, 50]" :page-size="size" layout="sizes, prev, pager, next" :total="sales.count" @size-change="onSizeChange" @current-change="onCurrentPageChange" />
    </div>
    <div class="responsive-table-shell sales-table-shell">
      <el-table :data="sales.rows" class="nowrap-table sales-table" stripe :default-sort="{ prop: 'sale_time', order: 'descending' }" @sort-change="onSortChange" size="medium" :fit="false">
        <el-table-column prop="sale_time" width="180" label="交易時間" sortable="custom" />
        <el-table-column prop="invoice_datetime" width="180" label="發票時間" sortable="custom" />
        <el-table-column prop="company_name" width="190" label="經銷商" sortable="custom" show-overflow-tooltip />
        <el-table-column prop="customer_name" label="客戶名稱" width="190" sortable="custom" show-overflow-tooltip />
        <el-table-column prop="location_name" label="擺放位置" width="240" sortable="custom" show-overflow-tooltip />
        <el-table-column prop="model_name" width="140" label="機型" show-overflow-tooltip />
        <el-table-column prop="asset_no" label="機台編號" width="130" sortable="custom" />
        <el-table-column prop="stop_watch" label="馬表數" width="120" sortable="custom" />
        <el-table-column prop="product_name" width="240" label="商品名稱" sortable="custom" show-overflow-tooltip />
        <el-table-column prop="payment_type" width="120" label="支付方式" sortable="custom" />
        <el-table-column prop="price" label="價格" width="100" sortable="custom" />
        <el-table-column prop="transaction_result" width="150" label="交易結果" sortable="custom" show-overflow-tooltip />
        <el-table-column prop="card_no" label="卡號" width="170" sortable="custom" show-overflow-tooltip />
        <el-table-column prop="full_invoice_no" width="180" label="發票號碼" sortable="custom" show-overflow-tooltip />
        <el-table-column prop="invoice_type" width="150" label="發票類型" show-overflow-tooltip />
        <el-table-column prop="invoice_status" width="150" label="發票狀態" show-overflow-tooltip />
        <el-table-column prop="gate_no" label="倉道" width="90" sortable="custom" />
        <el-table-column prop="carrier_number" label="載具號碼" width="180" show-overflow-tooltip />
        <el-table-column label="支付明細" width="120">
          <template v-if="scope.row.sale_detail" slot-scope="scope">
            <el-button round type="primary" @click="handleDetail(scope.row)">顯示</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="text-right">
      <el-pagination background :current-page.sync="currentPage" :page-sizes="[10, 20, 50]" :page-size="size" layout="sizes, prev, pager, next" :total="sales.count" @size-change="onSizeChange" @current-change="onCurrentPageChange" />
    </div>
    <el-dialog title="支付明細" :visible.sync="dialogVisible">
      <el-card>
        <div slot="header">
          <h2>支付方式：{{ sale_detail.payment_type | paytypeFilter }}</h2>
        </div>
        <div v-for="(value, key) in sale_detail.payment_detail" :key="key">
          <h3>{{ labels[key] }}：{{ value }}</h3>
        </div>
      </el-card>
      <el-card v-if="sale_detail.esun_detail && sale_detail.esun_detail.hasOwnProperty('OrderNo')">
        <div slot="header">
          <h2>玉山行動支付狀態</h2>
        </div>
        <div v-for="(value, key) in sale_detail.esun_detail" :key="key">
          <h3 v-if="key == 'OrderStatus'">{{ esun_keys[key] }}: {{ value | esunOrderStatusFilter }}</h3>
          <h3 v-else-if="esun_keys[key]">{{ esun_keys[key] }}: {{ value }}</h3>
        </div>
        <el-button type="primary" :disabled="esunDisabled" @click="esunQuery">更新交易狀態</el-button>
        <el-button type="primary" :disabled="esunDisabled" @click="esunCancel">取消交易</el-button>
        <el-button type="primary" :disabled="esunDisabled" @click="esunRefund">執行退款</el-button>
      </el-card>
    </el-dialog>
  </div>
</template>
<script>
import { v2GetSales, v2GetSalesCsv } from '@/api/transaction';
import { query, cancel, refund } from '@/api/esun';
import ExportExcel from '@/components/ExportExcel/export_sales.vue';
import search from './components/search.vue';
import dayjs from 'dayjs';
const methods = {
  async onSortChange(ordering) {
    if (!ordering.prop || !ordering.order) {
      return;
    }
    try {
      this.sale_ordering.prop = ordering.prop;
      if (ordering.order == null) {
        this.sale_ordering = null;
      } else if (ordering.order == 'descending') {
        this.sale_ordering.order = 'DESC';
      } else {
        this.sale_ordering.order = 'ASC';
      }
      this.currentPage = 1;
      this.onCurrentPageChange(1);
      await this.updatePage();
    } catch (error) {
      console.error('onSortChange error');
      console.error(error);
    }
  },
  showEsunError(data) {
    let msg = `操作失敗，錯誤代碼: ${data.ErrorCode}; 錯誤原因: 「${data.ErrorDesc}」`;
    this.$message({
      message: msg,
      type: 'error',
      duration: 60000,
      showClose: true,
    });
  },
  async esunQuery() {
    this.esunDisabled = true;
    let { data } = await query(this.sale_detail.payment_detail.OrderNo);
    if (data.Status == 'F') {
      this.showEsunError(data);
    } else {
      this.$message({
        message: '資料已刷新',
        type: 'success',
        duration: 6000,
      });
      this.sale_detail.esun_detail = this.sortWithKey(data.TransactionData);
    }
    this.esunDisabled = false;
  },
  async esunRefund() {
    this.esunDisabled = true;
    let { data } = await refund(this.sale_detail.payment_detail.OrderNo, this.sale_detail.esun_detail.OrderAmount);
    if (data.Status == 'F') {
      this.showEsunError(data);
    } else {
      this.sale_detail.esun_detail = this.sortWithKey(data.TransactionData);
    }
    this.esunDisabled = false;
  },
  async esunCancel() {
    this.esunDisabled = true;
    let { data } = await cancel(this.sale_detail.payment_detail.OrderNo);
    if (data.Status == 'F') {
      this.showEsunError(data);
    } else {
      this.sale_detail.esun_detail = this.sortWithKey(data.TransactionData);
    }
    this.esunDisabled = false;
  },
  async onSearch(condition) {
    this.condition = condition;
    this.currentPage = 1;
    try {
      this.onCurrentPageChange(1);
    } catch (error) {
      console.error(error);
    }
  },
  async onExportClick() {
    let now = dayjs();
    this.excel_filename = `${now.format('YYYYMMDDHHmmss')} 銷售紀錄.csv`;
    const { data } = (this.exportData = await v2GetSalesCsv(
      this.condition,
      {
        size: 9999999,
        page: 1,
      },
      this.sale_ordering,
      -1,
      this.excel_filename,
    ));
    this.excel_url = data.url;
  },

  async onSizeChange(size) {
    this.size = size;
    await this.updatePage();
  },
  async onCurrentPageChange(page) {
    this.page = page;
    await this.updatePage();
  },
  async updatePage() {
    this.sales = await v2GetSales(this.condition, { size: this.size, page: this.page }, this.sale_ordering);
  },
  async handleDetail(row) {
    this.dialogVisible = true;
    row.sale_detail.esun_detail = this.sortWithKey(row.sale_detail.esun_detail);
    this.sale_detail = row.sale_detail;
  },
  sortWithKey(obj) {
    const keys = Object.keys(obj);
    keys.sort();
    const sorted = keys.reduce((res, key) => {
      res[key] = obj[key];
      return res;
    }, {});
    return sorted;
  },
};
export default {
  components: {
    ExportExcel,
    search,
  },
  filters: {
    modelFilter(model) {
      const map = {
        BinShan168: '冰山168',
        NT861: '金雨861',
      };
      return map[model];
    },
    modelFilterClass(model) {
      const map = {
        BinShan168: 'success',
        NT861: 'primary',
      };
      return map[model];
    },
    invoiceFilter(key) {
      const map = {
        print: '紙本發票',
        donate: '愛心捐贈',
      };
      return map[key] ? map[key] : '載具';
    },
    invoiceFilterClass(key) {
      const map = {
        print: 'success',
        donate: 'danger',
      };
      return map[key] ? map[key] : 'primary';
    },
    dateTimeFilter(datetime) {
      return dayjs(datetime).utcOffset('+0800').format('YYYY/MM/DD HH:mm');
    },
    resultFilter(result) {
      const map = {
        Success: '成功',
        RefundSuccess: '出貨失敗 退款成功',
        RefundFailed: '出貨失敗 退款失敗',
      };
      return map[result];
    },
    paytypeFilter(type) {
      let type_lower = typeof type == 'string' ? type.toLowerCase() : '';
      const map = {
        cash: '現金',
        easycard: '悠遊卡',
        easycard_esun: '悠遊付',
        ipass: '一卡通',
        creditcard: '信用卡',
        jkos: '街口支付',
        line: 'LINE Pay',
        gama: '橘子支',
        pi: 'Pi錢包',
        ali: '支付寶',
        wallet: '玉山錢包',
        pxpay: '全支付',
        family: '全盈支付',
        taiwanpay: 'TaiwanPay',
      };
      return map[type_lower] ? map[type_lower] : `${type}`;
    },
    esunOrderStatusFilter(orderStatus) {
      const esunOrderStatusList = ['待扣款', '扣款成功', '扣款失敗', '待取消', '退款成功', '退款失敗'];
      return esunOrderStatusList[parseInt(orderStatus)];
    },
  },
  data() {
    return {
      esunDisabled: false,
      exportData: [],
      sales: {},
      condition: {},
      searchResult: {},
      excel_filename: '',
      excel_url: '',
      columns: [
        { field: 'sale_time', label: '交易時間' },
        { field: 'invoice_datetime', label: '發票時間' },
        { field: 'company_name', label: '經銷商' },
        { field: 'customer_name', label: '客戶名稱' },
        { field: 'location_name', label: '擺放位置' },
        { field: 'model_name', label: '機型' },
        { field: 'asset_no', label: '機台編號' },
        { field: 'stop_watch', label: '馬表數' },
        { field: 'product_name', label: '商品名稱' },
        { field: 'payment_type', label: '支付方式' },
        { field: 'price', label: '價格' },
        { field: 'transaction_result', label: '交易結果' },
        { field: 'card_no', label: '卡號' },
        { field: 'full_invoice_no', label: '發票號碼' },
        { field: 'invoice_type', label: '發票類型' },
        { field: 'invoice_status', label: '發票狀態' },
        { field: 'gate_no', label: '倉道' },
        { field: 'carrier_number', label: '載具號碼' },
        { field: 'order_no', label: '訂單編號' },
        { field: 'sale_detail', label: '支付明細' },
      ],
      currentPage: 1,
      size: 10,
      page: 1,
      sale_ordering: { prop: 'SaleTime', order: 'DESC' },
      dialogVisible: false,
      sale_detail: {},
      labels: {
        cash_insert: '投入現金',
        dispense: '找零',
        OrderNo: '特店交易編號',
        OrderTitle: '特店交易標題',
        OrderDT: '交易時間',
        CardNo: '卡號',
        TransDate: '交易日期',
        TransTime: '交易時間',
        ESVCOriginRRN: '電子票證交易序號',
        ApprovalNo: '授權碼',
        order_no: '後台訂單編號',
      },
      esun_keys: {
        Action: 'API 動作',
        Status: 'API 呼叫結果',
        ErrorCode: '錯誤代碼',
        ErrorDesc: '錯誤說明',
        OrderNo: '特店交易編號',
        OrderDT: '特店交易時間',
        BankOrderNo: '銀行交易編號',
        BankOrderDT: '銀行交易時間',
        WalletOrderNo: '支付機構交易編號',
        WalletOrderDT: '支付機構扣款成功時間',
        OrderCurrency: '特店交易幣別',
        OrderAmount: '特店交易金額',
        BankCurrency: '銀行使用幣別',
        RealOrderAmount: '特店實際交易金額',
        WalletCurrency: '支付機構使用幣別',
        RealWalletAmount: '支付機構實際扣款金額',
        RefundOrderAmount: '退款金額',
        BuyerID: '消費者條碼',
        OrderStatus: '交易狀態',
      },
    };
  },
  methods,
};
</script>
<style>
.responsive-table-shell {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}

.nowrap-table {
  width: 100%;
}

.sales-table {
  min-width: 3030px;
}

.nowrap-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
